import { MapPinType } from "components/GoogleMap/googleMapPin";
import GoogleMapOrError from "components/GoogleMapOrError";
import LabelledDivRow from "components/LabelledDivRow";
import moment from "moment";
import React from "react";
import { getGoogleUrl } from "utilities/googlemaps";
import { formatWrittenDateTimeUtc } from "utilities/momentutils";

interface Props {
  company: server.dto.Company
}

const CompanyGoogleMap = ({ company }: Props) => {
  const pin: MapPinType = company.isVenue === "active" ? {
    type: "venue",
  } : undefined;

  return <>
    <GoogleMapOrError
      mapId="DEMO_MAP_ID"
      coordinates={[{
        position: { lat: company.geoCode.location?.lat, lng: company.geoCode.location?.lng },
        pin,
        draggable: company.permissions.canModify,
        onLoaded: (_, marker) => {
          if (company.permissions.canModify) {
            google.maps.event.addListener(marker, "dragend", () => {
              const lat = typeof marker.position.lat === "function" ? marker.position.lat() : marker.position.lat;
              const lng = typeof marker.position.lng === "function" ? marker.position.lng() : marker.position.lng;
              window.CoreApi.Company.UpdateMarker({
                companyId: company.companyId,
                geoLocation: { lat, lng }
              });
            });
          }
          google.maps.event.addListener(marker, "click", () => {
            const url = getGoogleUrl(company.googlePlaceIdentifier, company.geoCode.location);
            if (url) {
              window.open(getGoogleUrl(company.googlePlaceIdentifier, company.geoCode.location));
            }
          });
        }
      }]}
      mapOptions={{
        center: { lat: company.geoCode.location?.lat, lng: company.geoCode.location?.lng },
        fullscreenControl: true,
        streetViewControl: true,
        mapTypeControl: true,
        zoom: company.geoCode.googleMapsZoom,
        scrollwheel: false
      }}
      height={400}
      geoCode={company.geoCode}
      onLoaded={map => {
        google.maps.event.addListener(map, "mouseover", () => {
          map.setOptions({
            scrollwheel: true
          });
        });

        google.maps.event.addListener(map, "mouseout", () => {
          map.setOptions({
            scrollwheel: false
          });
        });
      }}
    />

    {site.deploymentValues.debug && <LabelledDivRow bigPadding label={"Debug"}>
      <table className="s1_table clean">
        <tbody>
          <tr>
            <td>Google Place ID</td>
            <td>{company.googlePlaceIdentifier ?? "<null>"}</td>
          </tr>
          <tr>
            <td>GeoCode outcome</td>
            <td>{company.geoCode.outcome}</td>
          </tr>
          <tr>
            <td>Lookup date</td>
            <td>{company.geoCode.lookupUtc != null ? formatWrittenDateTimeUtc(moment.utc(company.geoCode.lookupUtc)) : "<null>"}</td>
          </tr>
        </tbody>
      </table>
    </LabelledDivRow>}
  </>;
};

export default CompanyGoogleMap;